var render, staticRenderFns
import script from "./index.vue?vue&type=script&lang=jsx&"
export * from "./index.vue?vue&type=script&lang=jsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports